import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import { ReactNode } from "react";

function TaskManagementOnly({ children }: { children: ReactNode }) {
  const isTaskManagementEnabled = useFlag(FLAGS.ENABLE_TASK_MANAGEMENT);

  if (isTaskManagementEnabled) {
    return children;
  }
  return null;
}

export default TaskManagementOnly;
